import z from 'zod'
import {
  nullSafeOptionalString,
  nullSafeString,
  nullSafeStringArray,
} from '../shared/schema'
import { promptTypeFieldLabels, promptVersionPromptFields } from '../../types'
const uniqueFields = ['tool0Description']
export const schema = z.object({
  title: nullSafeString(''),
  description: nullSafeString(''),
  fieldLabels: z.record(z.enum(promptTypeFieldLabels), z.string()).default({}),
  requiredPrompts: z.array(z.enum(promptVersionPromptFields)).default([]),
  optionalPrompts: z
    .array(z.enum([...promptVersionPromptFields, ...uniqueFields]))
    .default([]),
  requiredFields: nullSafeStringArray([]),
  promptType: z.literal('interactive_element_prompt'),
  promptSchemas: z
    .record(z.enum(promptVersionPromptFields), z.string())
    .default({}),
  trigger: nullSafeOptionalString(),
})

export const empty = Object.freeze(
  schema.parse({
    promptType: 'interactive_element_prompt',
    requiredPrompts: [],
    optionalPrompts: [],
  })
)

export type FirestorePromptInteractiveElementType = z.infer<typeof schema>
